import Login from '../pages/Login';
import { LogOut } from '../pages/logOut';
import RecoverPassword from '../pages/RecoverPassword';
import { VerifyEmail } from '../pages/verifyEmail';

export const sessionRoutes = {
  login: {
    path: '/login',
    component: Login,
    name: 'Login',
    visibility: ['public'],
  },
  logout: {
    path: '/logout',
    component: LogOut,
    name: 'Logout',
    visibility: ['public', 'onboarding', 'user'],
  },
  recoverPassword: {
    path: '/recover-password',
    component: RecoverPassword,
    name: 'Recover password',
    visibility: ['public', 'onboarding', 'user'],
  },
  verifyEmail: {
    path: '/verify-email',
    component: VerifyEmail,
    name: 'Verify email',
    visibility: ['onboarding', 'user'],
  },
};
